// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"modal_modalOverlay__yZFp3","fadein":"modal_fadein__2GQTM","modalBody":"modal_modalBody__138cm","close":"modal_close__2nFio"};